import { Layout } from "antd";
import React from "react";
import PublicHeader from "../../layout/publicLayout/header";
import QueryForm from "../homeStore/queryForm";
import PageHeader from "../../layout/protectedLayout/protectedLayoutStore/headers/pageHeader";

const Thankyou = () => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "2rem",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
    color: "#333",
  };
  const headingStyle: React.CSSProperties = {
    fontSize: "2rem",
    marginBottom: "1rem",
  };

  const messageStyle: React.CSSProperties = {
    fontSize: "1.2rem",
    marginBottom: "2rem",
    maxWidth: "500px",
  };

  const linkStyle: React.CSSProperties = {
    textDecoration: "none",
    color: "#007bff",
    margin: "0.5rem 0",
  };
  return (
    <Layout style={{ background: "#f0f7ff" }}>
      <PageHeader hideSideNav={true} />
      <section className="home-store">
        <QueryForm userName={"Mandira Gundi"} />
      </section>
    </Layout>
  );
};

export default Thankyou;
